export default __webpack_public_path__ + "static/search-71a06dd2133523fd8afcef719e9c5f40.gif";